import React from 'react';
import clsx from 'clsx';
import styles from './Select.module.scss';

const Select = ({
  value,
  onChange,
  disabled = false,
  variant = 'default',
  className,
  children,
  ...rest
}) => {
  return (
    <select
      value={value}
      onChange={onChange}
      disabled={disabled}
      className={clsx(
        styles.root,
        styles[variant],
        disabled && styles.disabled,
        className
      )}
      {...rest}
    >
      {children}
    </select>
  );
};

export default Select;
